import { BreadcrumbService } from 'src/app/shared/service/breadcrumb.service';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Breadcrumb } from '../../../../../utils/models/layout.interface';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import * as navigation from '../../../../../utils/constants/layout/navigation.json';

export interface TitleItem {
  path: string;
  name: string;
  breadCrumb?: string[];
  hasCustomBreadcrumb?: boolean;
};

export interface DataItem {
  name: string;
  breadCrumb: Breadcrumb[];
};
@Component({
  selector: 'app-topnavbar-breadcrumb',
  templateUrl: './topnavbar-breadcrumb.component.html',
  styleUrls: ['./topnavbar-breadcrumb.component.scss'],
  imports: [
    CommonModule,
    SharedModule
  ],
  standalone: true
})
export class TopnavbarBreadcrumbComponent implements OnInit {
  @Input() title: string;
  breadCrumbStaticItems: DataItem[] = [];
  breadCrumbPage: Breadcrumb[] = [];
  constructor(
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly breadcrumbService: BreadcrumbService
  ) {
    this.breadCrumbStaticItems = this.generateData(navigation?.titles as TitleItem[]);
  }

  ngOnInit(): void {
    this.setFirstBreadcrumb();
    this.listenChangeRoute();
    this.listenChangeBreadcrumb();
  }

  setFirstBreadcrumb() {
    const breadcrumb = sessionStorage.getItem('breadcrumb');
    if (breadcrumb) {
      this.setBreadcrumb(JSON.parse(breadcrumb));
      return;
    }
    const title = this.findTitle();
    const breadCrumb = this.breadCrumbStaticItems.find(item => title === item.name)?.breadCrumb;
    this.setBreadcrumb(breadCrumb ?? []);
  }

  listenChangeRoute() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((res) => {
      const title = this.findTitle();
      const item: any = this.breadCrumbStaticItems.find(item => title === item.name);
      if (item?.hasCustomBreadcrumb) {
        return;
      }
      this.setBreadcrumb(item?.breadCrumb ?? []);
    });
  }

  listenChangeBreadcrumb() {
    this.breadcrumbService.breadcrumb$.subscribe((breadcrumbs) => {
      if (breadcrumbs === this.breadCrumbPage) {
        return;
      }
      // verifica se possui itens extremamente iguais, se tiver, remove o item mais a direita
      if (breadcrumbs.some((item, index) => item.value === breadcrumbs[index + 1]?.value)) {
        breadcrumbs.splice(breadcrumbs.length - 1, 1);
      }
      this.breadCrumbPage = breadcrumbs;
      sessionStorage.setItem('breadcrumb', JSON.stringify(breadcrumbs));
      this.cdr.detectChanges();
    });
  }

  findTitle(): string {
    const url = this.router.url.includes('?') ? this.router.url.split('?')[0] : this.router.url;
    const titles = navigation?.titles ?? [];
    const exact = titles.find(item => item.path === url)?.name;
    if (exact) return exact;

    // Rotas parametrizadas (ex.: /conexoes/detalhes/:id)
    return titles.find(item => {
      if (!item.path.includes(':')) return false;
      const pattern = `^${item.path.replace(/:[^/]+/g, '[^/]+')}$`;
      return new RegExp(pattern).test(url);
    })?.name;
  }

  private setBreadcrumb(breadCrumb: Breadcrumb[]) {
    this.breadcrumbService.setBreadcrumb(breadCrumb);
  }

  generateData(titles: TitleItem[]): DataItem[] {
    return titles.map((title: TitleItem) => {
      // Quebra o path em partes para montar os breadcrumbs com os caminhos corretos
      const pathParts = title.path.split('/').filter(Boolean); // remove vazios do início

      // Gera a lista de breadcrumbs com base na hierarquia
      const breadCrumb: Breadcrumb[] = title.breadCrumb?.map((value: string, index: number) => {
        const fullPath = '/' + pathParts.slice(0, index + 1).join('/');
        return { path: fullPath, value };
      });

      return {
        name: title.name,
        breadCrumb,
        hasCustomBreadcrumb: title.hasCustomBreadcrumb
      };
    });
  }

  isRouterRoot() {
    return this.router.url === '/';
  }

  onNavigateTo(path: string, isLast: boolean) {
    if (isLast) {
      return;
    }
    const urlHasQueryParams = path.includes('?');

    if (urlHasQueryParams) {
      const url = path.split('?')[0];
      const queryParams = path.split('?')[1];
      const queryParamsObject = queryParams.split('&').reduce((acc, curr) => {
        const [key, value] = curr.split('=');
        acc[key] = decodeURIComponent(value);
        return acc;
      }, {});
      this.router.navigate([url], {
        queryParams: queryParamsObject
      });
    } else {
      this.router.navigate([path]);
    }
  }

}
